<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando dados...</p></div>
    <MensagemAlerta class="row-space" v-if="msg" :mensagem="msg" />

    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEdicao.cddrivegrupo) }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Nome</label>
                <input type="text" v-model="objEdicao.nmdrivegrupo" required maxlength="100" v-uppercase />
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Observações</label>
                <textarea v-model="objEdicao.obs" maxlength="3000" rows="5" style="resize: none;"/>
            </div>
        </div>

        <div class="row-end">
            <label for="ckAtivo">Ativo</label>
            <input type="checkbox" class="input-checkbox" id="ckAtivo" v-model="ckAtivo" />
        </div>

        <div class="row-end">
            <button type="button" class="btn-cancel" @click="cancelForm">Cancelar</button>
            <button type="button" class="btn-confirm" @click="salvarDados">Salvar</button>
        </div>
    </div>
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarDriveGrupo } from '@/models/driveGrupo';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import MensagemAlerta from '@/components/utils/MensagemAlerta.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({idEdicao: {type: Number, default: 0}});

const ckAtivo = ref(false);
const isLoading = ref(false);
const msg = ref(null);
const objEdicao = ref(criarDriveGrupo());


const cancelForm = () => {emit('close');}


const lerDados = async() => {
    try{
        isLoading.value = true;
        msg.value       = null;
        if (props.idEdicao > 0) {
            try{
                const req = await Api.getCadastroById('drive/grupo', props.idEdicao);
                Object.assign(objEdicao.value, req[0]);
            }catch (error){msg.value = error}
        }else{
            objEdicao.value.idep        = globalStore.idep;
        }
        objEdicao.value.idlogin         = globalStore.idlogin;
        ckAtivo.value                   = objEdicao.value.ckativo === 'S';        
    } catch (error) {msg.value = error;
    }finally{isLoading.value=false;}
}

const salvarDados = async() => {
    if (!objEdicao.value.nmdrivegrupo || objEdicao.value.nmdrivegrupo.trim() === '') {msg.value='Informe o nome do grupo'; return;}
    try {
        isLoading.value             = true;
        msg.value                   = null;
        objEdicao.value.ckativo     = ckAtivo.value ? 'S' : 'N';
        const response              = await Api.genericPut('/cad/drive/grupo', objEdicao.value);
        if (response.bolok === 1){
            emit('save');
            emit('close');
        }else{
            msg.value = response.erro;
        }
    } catch (error) {msg.value = error;
    } finally{isLoading.value=false;}
}

onMounted(lerDados)
</script>